export const aboutInfo = {
  brandName: '爆料网',
  subtitle: '第一手独家爆料资讯平台',
  introduction:
    '爆料网成立于2018年，是国内领先的独立爆料资讯平台。我们致力于为公众提供真实、及时、深度的爆料内容，涵盖娱乐圈内幕、社会热点追踪、商业秘闻揭露、科技行业洞察、国际大事解读等多个领域。',
  mission:
    '我们的使命是打破信息壁垒，让每一个普通人都能了解事件背后的真相。在信息爆炸的时代，我们不满足于表面的新闻报道，而是通过深度调查和权威信源，为读者呈现事件的全貌和深层逻辑。',
  vision:
    '我们相信，真实的信息是社会进步的基石。爆料网将继续坚持独立、客观、深度的报道原则，成为公众获取优质资讯的首选平台。',
  stats: [
    { label: '平台成立', value: '2018年' },
    { label: '累计爆料', value: '50,000+' },
    { label: '活跃读者', value: '800万+' },
    { label: '独家报道', value: '3,000+' },
  ],
  values: [
    {
      title: '真实可信',
      description: '每一条爆料都经过多源交叉验证，确保信息的真实性和准确性。我们宁可慢一点，也不会发布未经核实的消息。',
      icon: 'ri-shield-check-line',
    },
    {
      title: '独立客观',
      description: '保持编辑独立性，不接受任何形式的利益输送。我们的报道只为真相和公众利益服务。',
      icon: 'ri-scales-line',
    },
    {
      title: '深度独家',
      description: '不满足于表面信息，深入挖掘事件背后的真相。我们的调查团队遍布全国，确保触达第一手信源。',
      icon: 'ri-search-eye-line',
    },
    {
      title: '保护信源',
      description: '建立严格的信息源保护机制，确保爆料人的安全和隐私。我们深知每一位爆料人所承担的风险。',
      icon: 'ri-lock-line',
    },
  ],
  reputation: [
    {
      quote: '爆料网的报道一向严谨可靠，是我获取深度资讯的首选渠道。他们的调查报道多次推动了实际问题的解决。',
      source: '某知名媒体人',
      role: '资深媒体从业者',
    },
    {
      quote: '作为律师，我非常欣赏爆料网对事实的尊重。他们的每篇报道都有据可查，在一定程度上推动了社会的透明化进程。',
      source: '张律师',
      role: '知名法律专家',
    },
    {
      quote: '爆料网是我们日常舆情监测中重点关注的信源之一。他们的独家内容多次被主流媒体引用和跟进报道。',
      source: '某公关机构负责人',
      role: '品牌公关专家',
    },
    {
      quote: '在信息泛滥的时代，爆料网坚持做有深度、有温度的报道，这种坚守让人敬佩。',
      source: '李教授',
      role: '新闻传播学者',
    },
  ],
  contact: {
    email: 'tips@baoliaowang.com',
    wechat: 'baoliaowang_official',
    weibo: '@爆料网官方',
    address: '北京市朝阳区建国路88号SOHO现代城A座',
    phone: '010-8888-6666',
    workingHours: '周一至周五 9:00 - 18:00',
  },
};

export const faqItems = [
  {
    question: '爆料网的爆料信息都经过核实吗？',
    answer: '是的，我们每一条发布的爆料信息都经过了严格的核实流程。我们的编辑团队会对信源进行多角度交叉验证，确保信息的真实性和可靠性。对于暂时无法完全核实的信息，我们会明确标注"待核实"，不会以确认事实的方式发布。',
  },
  {
    question: '如何向爆料网投稿或提供线索？',
    answer: '您可以通过以下方式向我们提供线索：1）发送邮件至 tips@baoliaowang.com；2）通过微信公众号"爆料网官方"留言；3）使用我们网站上的匿名投稿功能。我们建立了完善的信源保护机制，确保每一位爆料人的安全和隐私得到充分保障。',
  },
  {
    question: '爆料网的内容是否收费？',
    answer: '爆料网的绝大部分内容对读者完全免费开放。我们通过广告和品牌合作来维持运营，不会向普通读者收取任何费用。部分深度调查报告可能需要注册会员后才能阅读，但会员注册也是完全免费的。',
  },
  {
    question: '如果发现爆料内容失实，如何申请更正？',
    answer: '我们高度重视报道的准确性。如果您认为我们的某篇报道存在事实性错误，请发送邮件至 tips@baoliaowang.com，并附上相关证据材料。我们的编辑团队将在收到申请后48小时内进行核实，如确认有误，我们会第一时间发布更正声明。',
  },
  {
    question: '爆料网的团队背景是什么？',
    answer: '爆料网的核心编辑团队由来自主流媒体、法律和学术界的资深人士组成。我们的调查记者遍布全国主要城市，同时还与多个国际调查新闻机构保持着密切合作。我们坚持编辑独立原则，不受任何商业或政治利益的影响。',
  },
  {
    question: '如何与爆料网进行商务合作或广告投放？',
    answer: '我们欢迎品牌方与我们进行广告合作或品牌内容合作。请发送合作意向至 tips@baoliaowang.com，并注明"商务合作"。我们的商务团队会在3个工作日内与您联系，根据您的需求提供定制化的合作方案。请注意，所有合作内容都会明确标注为广告或赞助内容。',
  },
];